<template>
  <!DOCTYPE svg PUBLIC "-//W3C//DTD SVG 1.1//EN" "http://www.w3.org/Graphics/SVG/1.1/DTD/svg11.dtd">
  <svg
    version="1.1"
    id="Layer_1"
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    x="0px"
    y="0px"
    width="21px"
    height="21px"
    viewBox="0 0 21 21"
    enable-background="new 0 0 21 21"
    xml:space="preserve"
  >
    <g id="icon">
      <path
        d="M3.3925,18h-0.1851c-0.1146,0,-0.2075,-0.0929,-0.2075,-0.2075v-4.5851c0,-0.1146,0.0929,-0.2075,0.2075,-0.2075h0.1851c0.1146,0,0.2075,0.0929,0.2075,0.2075v4.5851C3.6,17.9071,3.5071,18,3.3925,18zM11,17.7925v-4.5851c0,-0.1146,-0.0929,-0.2075,-0.2075,-0.2075h-0.1851c-0.1146,0,-0.2075,0.0929,-0.2075,0.2075v4.5851c0,0.1146,0.0929,0.2075,0.2075,0.2075h0.1851C10.9071,18,11,17.9071,11,17.7925zM6.6,16.7942v-3.5884c0,-0.1137,-0.0921,-0.2058,-0.2058,-0.2058h-0.1884c-0.1137,0,-0.2058,0.0921,-0.2058,0.2058v3.5884c0,0.1137,0.0921,0.2058,0.2058,0.2058h0.1884C6.5079,17,6.6,16.9079,6.6,16.7942zM8,16.7942v-3.5884c0,-0.1137,-0.0921,-0.2058,-0.2058,-0.2058h-0.1884c-0.1137,0,-0.2058,0.0921,-0.2058,0.2058v3.5884c0,0.1137,0.0921,0.2058,0.2058,0.2058h0.1884C7.9079,17,8,16.9079,8,16.7942zM9.3716,13h-0.4432c-0.2366,0,-0.4284,0.1918,-0.4284,0.4284v3.1432c0,0.2366,0.1918,0.4284,0.4284,0.4284h0.4432c0.2366,0,0.4284,-0.1918,0.4284,-0.4284v-3.1432C9.8,13.1918,9.6082,13,9.3716,13zM4.9716,13h-0.4432c-0.2366,0,-0.4284,0.1918,-0.4284,0.4284v3.1432c0,0.2366,0.1918,0.4284,0.4284,0.4284h0.4432c0.2366,0,0.4284,-0.1918,0.4284,-0.4284v-3.1432C5.4,13.1918,5.2082,13,4.9716,13z"
        fill="currentColor"
      />
      <path
        d="M5.304,18H4.396c-0.1083,0,-0.196,-0.0878,-0.196,-0.196v-0.0079c0,-0.1083,0.0878,-0.296,0.196,-0.296h0.9079c0.1083,0,0.196,0.1878,0.196,0.296v0.0079C5.5,17.9122,5.4122,18,5.304,18zM7.6,17.804v-0.0079c0,-0.1083,-0.0878,-0.296,-0.196,-0.296H6.496c-0.1083,0,-0.196,0.1878,-0.196,0.296v0.0079c0,0.1083,0.0878,0.196,0.196,0.196h0.9079C7.5122,18,7.6,17.9122,7.6,17.804zM9.7,17.804v-0.0079c0,-0.1083,-0.0878,-0.296,-0.196,-0.296H8.596c-0.1083,0,-0.196,0.1878,-0.196,0.296v0.0079c0,0.1083,0.0878,0.196,0.196,0.196h0.9079C9.6122,18,9.7,17.9122,9.7,17.804z"
        fill="currentColor"
      />
      <path
        d="M14.93,19.5H2.07c-0.3148,0,-0.57,-0.2552,-0.57,-0.57V7.07c0,-0.3148,0.2552,-0.57,0.57,-0.57h12.86c0.3148,0,0.57,0.2552,0.57,0.57v11.86C15.5,19.2448,15.2448,19.5,14.93,19.5z"
        fill="none"
        stroke="currentColor"
        stroke-width="1"
        stroke-linecap="round"
        stroke-miterlimit="10"
        stroke-linejoin="round"
      />
      <polyline
        points="7.5,6.5714 7.5,10.5 9.5,10.5 9.5,6.5714"
        fill="none"
        stroke="currentColor"
        stroke-width="1"
        stroke-linecap="round"
        stroke-miterlimit="10"
        stroke-linejoin="round"
      />
      <path
        d="M3.7,4.5h12.73c0.5909,0,1.07,0.4791,1.07,1.07V17.3"
        fill="none"
        stroke="currentColor"
        stroke-width="1"
        stroke-linecap="round"
        stroke-miterlimit="10"
        stroke-linejoin="round"
      />
      <path
        d="M5.7,2.5h12.77c0.5689,0,1.03,0.4611,1.03,1.03V15.3"
        fill="none"
        stroke="currentColor"
        stroke-width="1"
        stroke-linecap="round"
        stroke-miterlimit="10"
        stroke-linejoin="round"
      />
    </g>
  </svg>
</template>

<script setup lang="ts"></script>
